import { render, staticRenderFns } from "./CommentAttachmentList.vue?vue&type=template&id=2e02cb96&"
import script from "./CommentAttachmentList.vue?vue&type=script&lang=ts&"
export * from "./CommentAttachmentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports